import React from 'react';
import { Phone } from 'lucide-react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section className="py-24 bg-[#1B4332] relative overflow-hidden" data-id="element-16">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-17">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#2D6A4F] rounded-full blur-3xl opacity-50" data-id="element-18"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-[#2D6A4F] rounded-full blur-3xl opacity-50" data-id="element-19"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-21">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-white mb-8" data-id="element-22">
            <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" data-id="element-23"></div>
            <span className="text-sm font-bold tracking-wider uppercase" data-id="element-24">
              Your Outdoor Space Deserves Better
            </span>
          </div>

          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-25">
            Ready to Transform Your Property?
          </h2>

          <p className="text-xl text-white/80 mb-12 max-w-2xl mx-auto" data-id="element-26">
            Call I&A Landscaping LLC today for your free, no-obligation
            estimate. Let's build something you can be proud of.
          </p>

          <a href="tel:4402221065" className="inline-flex items-center justify-center gap-4 bg-[#C41E24] hover:bg-[#a8181e] text-white px-10 py-5 rounded-xl font-bold text-2xl transition-all transform hover:scale-105 shadow-2xl" data-id="element-27">
            <Phone size={32} data-id="element-28" />
            <span data-id="element-29">(440) 222-1065</span>
          </a>

          <a href="mailto:iandalanscaping@gmail.com" className="inline-block mt-6 text-white/70 hover:text-white transition-colors text-sm" data-id="element-30">
            iandalanscaping@gmail.com
          </a>
          <p className="text-white/60 mt-3 text-sm uppercase tracking-widest" data-id="element-31">
            Serving All of Northeast Ohio
          </p>
        </motion.div>
      </div>
    </section>;
}